import { useWatch } from 'react-hook-form';
import { useInvoiceHydration } from '@/hooks/queries/useInvoiceHydration';
import { ChiTietHoaDonBanHangDichVu } from '@/types/schemas';
import { ErpInputTableV2 } from '@/components/custom/erp';
import { getDetailTableColumns } from './columns';
import { FormMode } from '@/types/form';

interface DetailTabProps {
  rows: ChiTietHoaDonBanHangDichVu[];
  selectedRowUuid: string | null;
  handleRowClick: (...args: BanHangRecord[]) => void;
  handleAddRow: () => void;
  handleDeleteRow: () => void;
  handleCopyRow: () => void;
  handlePasteRow: () => void;
  handleMoveRow: (direction: 'up' | 'down') => void;
  handleCellValueChange: (rowUuid: string, field: string, newValue: BanHangValue) => void;
  formMode: FormMode;
}

const DETAIL_ACTION_ORDER = ['add', 'delete', 'copy', 'paste', 'moveUp', 'moveDown', 'export', 'pin'] as const;
const noop = () => {};

export default function DetailTab({
  rows,
  selectedRowUuid,
  handleRowClick,
  handleAddRow,
  handleDeleteRow,
  handleCopyRow,
  handlePasteRow,
  handleMoveRow,
  handleCellValueChange,
  formMode
}: DetailTabProps) {
  // Sử dụng useWatch để lấy giá trị real-time từ form
  const [ma_ngv] = useWatch({ name: ['ma_ngv'] });
  const [dien_giai] = useWatch({ name: ['dien_giai'] });
  useInvoiceHydration({
    rows,
    enabled: formMode !== 'add',
    onHydrated: (uuid, invoice) => handleCellValueChange(uuid, 'id_hd_data', invoice)
  });

  const actions = {
    add: handleAddRow,
    delete: handleDeleteRow,
    copy: handleCopyRow,
    paste: handlePasteRow,
    moveUp: () => handleMoveRow('up'),
    moveDown: () => handleMoveRow('down'),
    export: noop,
    pin: noop
  };

  return (
    <div className='h-screen overflow-hidden'>
      <ErpInputTableV2<ChiTietHoaDonBanHangDichVu>
        rows={rows}
        onRowClick={handleRowClick as BanHangRecord}
        selectedRowId={selectedRowUuid || undefined}
        columns={getDetailTableColumns(ma_ngv || '1', dien_giai, handleCellValueChange)}
        getRowId={row => row?.uuid || ''}
        actionsDisabled={formMode === 'view'}
        actionOrder={DETAIL_ACTION_ORDER as BanHangRecord}
        actions={actions}
        className='h-full'
      />
    </div>
  );
}
